<template>
  <div v-if="term" class="termination-details">
    <table class="table table-condensed table-sm">
      <tbody>
      <tr>
        <td class="bold text-nowrap">Plans</td>
        <td class="text-right flex-wrap">{{ term.planNames.join(", ") }}</td>
      </tr>
      <tr>
        <td class="bold text-nowrap">Termination Date</td>
        <td class="text-right">{{ $formatters.date(term.terminationDate) }}</td>
      </tr>
      <tr>
        <td class="bold text-nowrap">Termination Runout Date</td>
        <td class="text-right">{{ $formatters.date(term.terminationRunOutDate) }}</td>
      </tr>
      <tr>
        <td class="bold text-nowrap">Will handle grace period?</td>
        <td class="text-right">{{ $formatters.boolean(term.willAdministerGracePeriod) }}</td>
      </tr>
      <tr>
        <td class="bold text-nowrap">Will administer runout?</td>
        <td class="text-right">{{ $formatters.boolean(term.willAdministerRunout) }}</td>
      </tr>
      <tr>
        <td class="bold text-nowrap">Cobra services?</td>
        <td class="text-right">{{ $formatters.boolean(term.terminateCobraService) }}</td>
      </tr>
      <tr>
        <td class="bold text-nowrap">Cobra special billing?</td>
        <td class="text-right">{{ $formatters.boolean(term.terminateCobraSpecialBilling) }}</td>
      </tr>
      <tr v-if="term.primarySurveyResponse">
        <td class="bold text-nowrap">Termination Reason</td>
        <td class="text-right flex-wrap">{{ term.primarySurveyResponse }}</td>
      </tr>      
      <tr>
        <td class="bold text-nowrap">Termination Notes</td>
        <td class="text-right flex-wrap">{{ term.terminationNotes }}</td>
      </tr>
      <template v-if="shouldShowCancelLink">
        <tr>
          <td>
            <hr>
          </td>
        </tr>
        <tr>
          <td>
            <a href="#" @click.prevent="cancelTermination" class="text-right">Cancel termination?</a>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
  import {toastService} from "../../framework/utils/toast-service";

  export default {
    props: ["item"],
    data() {
      return {
        term: null
      }
    },
    async created() {
      if(this.isInternalUser) {
        let url = '';
        if (this.isFeatureEnabled("non-workflow-termination")) {
          url = `/employer/${this.item.employerId}/termination/${this.item.terminationId}`;
        }
        else {
          url = '/terminationworkflow/ByWorkflowId/';
          if (this.item.itemType == 'termination-cancelled') {
            url += `${this.item.workflowIdThatWasCancelled}`;
          } else {
            url += `${this.item.workflowId}`;
          }
        }

        this.term = await romeApi.get(url);
      }
    },
    computed: {
      ...amfx.map("session", "isInternalUser"),
      shouldShowCancelLink() {
        let redesignedTermIsNotCompleted = this.isFeatureEnabled("non-workflow-termination") && this.term.terminationStatus != 1;
        let oldTermIsNotCompleted = !this.isFeatureEnabled("non-workflow-termination") && this.term.completedTermination == false;

        return this.item
          && !['ewf-termination-retain-business', 'termination-cancelled','ewf-termination-retain-business-v2'].includes(this.item.itemType)
          && (this.item.cardProcessor != 2 || (this.item.cardProcessor == 2 && (redesignedTermIsNotCompleted || oldTermIsNotCompleted)))
      }
    },
    methods: {
      async cancelTermination() {

        await modalService.confirm("Are you sure you want to cancel this termination?");

        if (this.isFeatureEnabled("non-workflow-termination")) {
          await romeApi.post(`/employer/${this.term.employerId}/termination/${this.term.terminationId}/cancel`);
        }
        else {
          await romeApi.post(`/terminationworkflow/${this.term.terminationWorkflowId}/cancel`);
        }

        toastService.success("Termination cancelled successfully", "Termination Cancelled");

        this.busy = true;

        await Promise.all([
          this.$store.dispatch("cobraConfig/load", {employerId: this.item.employerId, force: true}),
          this.$store.dispatch("employer/load", {employerId: this.item.employerId, refreshSameEmployer: true}),
          this.$store.dispatch("plans/load", {employerId: this.item.employerId, refreshSameEmployer: true}),
          this.item && this.item.planIds && this.item.planIds.length === 1 ? this.$store.dispatch("plan/load", {planId: this.item.planIds[0], refreshSamePlan: true}) : Promise.resolve,
          this.$store.dispatch("actionItems/refresh")
        ]);

        this.refreshPermissions();

        await this.$store.dispatch("actionItems/refresh");

        this.busy = false;
      },
    },
  };
</script>


<style lang="scss" scoped>

  .termination-details {
    table {
      margin-bottom: 0;

      tbody {
        border: 0;
      }

      td {
        border-top: transparent;
        padding: 0;
      }

      .bold {
        font-weight: bold;
      }
    }

    hr {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
    }

  }
</style>



// WEBPACK FOOTER //
// src/action-items/types/TerminationActionItem.vue